module.exports = __webpack_public_path__ + "static/media/4.e15a76a1.jpg";